import { render, staticRenderFns } from "./Attach.vue?vue&type=template&id=5ffe9546&"
import script from "./Attach.vue?vue&type=script&lang=js&"
export * from "./Attach.vue?vue&type=script&lang=js&"
import style0 from "./Attach.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports